import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { LayoutComponent } from "../../shared/layout/layout.component";

/** "Deze link werkt niet meer": expired, used or broken invitation link (docs/invite-flow.md). */
@Component({
  selector: "app-invite-expired",
  standalone: true,
  imports: [TranslatePipe, LayoutComponent],
  templateUrl: "./invite-expired.component.html",
  styleUrl: "./invite-expired.component.css",
})
export class InviteExpiredComponent {
  readonly customerServiceUrl = "https://www.ns.nl/klantenservice";
}
